import { IDLE_PROMPT_TIMEOUT, IDLE_TIMEOUT } from 'constants/messages.constant';
import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useIdleTimer } from 'react-idle-timer';
import { useTimer } from 'react-timer-hook';
import { clearSessionData, padToTwo } from 'utils';
import IdleModal from './components/IdleModal';

const withIdleTimer = (Component) => {
  const ComponentWithIdleTimer = (props) => {
    const [displayModal, setDisplayModal] = useState(false);
    const onPrompt = () => {
      let path = window.location.pathname;
      if (!idleIgnoredPaths.includes(path)) setDisplayModal(true);
    };

    const onIdle = () => {
      let path = window.location.pathname;
      if (!idleIgnoredPaths.includes(path)) {
        clearSessionData();
        window.location.href = '/signin';
      }
    };
    const { reset } = useIdleTimer({
      onPrompt,
      onIdle,
      timeout: IDLE_TIMEOUT,
      promptTimeout: IDLE_PROMPT_TIMEOUT,
      events: [
        'mousemove',
        'keydown',
        'wheel',
        'DOMMouseScroll',
        'mousewheel',
        'mousedown',
        'touchstart',
        'touchmove',
        'MSPointerDown',
        'MSPointerMove',
        'visibilitychange',
      ],
      immediateEvents: [],
      debounce: 0,
      throttle: 800,
      eventsThrottle: 800,
      element: document,
      startOnMount: true,
      startManually: false,
      stopOnIdle: false,
      crossTab: false,
      name: 'idle-timer',
      syncTimers: 0,
      leaderElection: false,
    });

    const idleIgnoredPaths = ['/signin', '/signup', '/reset-password'];

    return (
      <>
        <IdleModal
          show={displayModal}
          onClick={() => {
            reset();
            setDisplayModal(false);
          }}
        />
        <Component {...props} />
      </>
    );
  };

  return ComponentWithIdleTimer;
};

export default withIdleTimer;
